import { render, staticRenderFns } from "./PreMatriculasIndexPage.vue?vue&type=template&id=2cadcc1d"
import script from "./PreMatriculasIndexPage.vue?vue&type=script&lang=js"
export * from "./PreMatriculasIndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports